export const rewardsPaneHeaderText = "Uu2Fmb";
export const microsoftRewardsTitle = "UE7cgc";
export default {rewardsPaneHeaderText,microsoftRewardsTitle};